import type { FC } from "react";
import { normalizeNullableText } from "../../../../utils/textEncoding";

interface props {
  text: string;
  color?: string;
}

export const TextTableValue: FC<props> = ({
  text,
  color = "var(--app-text)",
}) => {
  const safeText = normalizeNullableText(text, "-");

  // Per-value color (e.g. green/red deltas), so it's an inline style.
  return (
    <div title={safeText} style={{ color }}>
      {safeText}
    </div>
  );
};
